module.exports = __webpack_public_path__ + "img/header_logo.56a47286.png";